export default {
    install(Vue, options) {
        if (!options.key) {
            console.error("[Dr Web-Messenger Plugin] No key specified");

            return false;
        }

        if (!options.auth) {
            console.info(
                "[Dr Web-Messenger Plugin] No auth key specified, auth will be ignored"
            );
        }

        let script = document.createElement("script");
        script.src =
            process.env.VUE_APP_WM_URL + options.key + "/conversation.js";

        window.bbReady = function(bb) {
            if (
                !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                    navigator.userAgent
                ) &&
                window.location !== window.parent.location
            ) {
                //bb("open");
                // comment it for now, as we are not desktop related
            }
            window.bb = bb;
        };

        document.head.appendChild(script);
    }
};
